import {Button, Stack} from "@mui/material";
import FilterTitle from "components/FilterTitle";
import MixedFilter from "pages/Material/list/components/MixedFilter";
import MultipleSelect from "components/MultipleSelect";
import React, {Dispatch, SetStateAction} from "react";
import {Category, FilterItem} from "pages/Material/types";
import {KeywordsQuery, useSubcategoriesQuery} from "@generated/graphql";
import useMaterialType from "pages/Material/useMaterialType";

interface MaterialFiltersProps {
  onCloseModal?: () => void;
  setSelectedCategory: Dispatch<SetStateAction<Category | null>>;
  setSelectedSubcategory: Dispatch<SetStateAction<string>>;
  setSelectedKeywords: Dispatch<SetStateAction<string[]>>;
  keywordList: KeywordsQuery['keywords']['data'];
  setMixedFilterValue: Dispatch<SetStateAction<FilterItem | null>>;
  setKeywordsFilter: Dispatch<SetStateAction<string[]>>;
  mixedFilterValue: FilterItem | null;
  selectedKeywords: string[];
}

const MaterialFilters = ({
                           onCloseModal,
                           setKeywordsFilter,
                           selectedKeywords,
                           setSelectedKeywords,
                           mixedFilterValue,
                           setMixedFilterValue,
                           setSelectedSubcategory,
                           setSelectedCategory,
                           keywordList
                         }: MaterialFiltersProps) => {
  const type = useMaterialType();
  const {data: subcategories, loading: loadingSubcategories, refetch} = useSubcategoriesQuery({
    variables: {
      filter: {
        categoryType: type
      },
      pagination: {page: 0, limit: 10}
    },
  });

  const subcategoryList = subcategories?.subcategories.data;


  const onClearFilters = () => {
    setSelectedCategory(null);
    setMixedFilterValue(null);
    setSelectedSubcategory('');
    setSelectedKeywords([]);
    setKeywordsFilter([]);
  }

  const onSetFilters = () => {
    if (mixedFilterValue) {
      setSelectedCategory(mixedFilterValue?.category);
      setSelectedSubcategory(mixedFilterValue?.id);
    }
    setKeywordsFilter(selectedKeywords);
    onCloseModal?.();
  }


  const onMixedFilterInputChange = (inputValue: string) => {
    refetch({
      filter: {
        categoryType: type,
        title: inputValue,
      }
    })
  }

  return (
    <Stack spacing={4}>
      <FilterTitle onClear={onClearFilters}/>
      <Stack spacing={3}>
        <MixedFilter
          options={subcategoryList || []}
          value={mixedFilterValue}
          onChange={setMixedFilterValue}
          onInputChange={onMixedFilterInputChange}
          loading={loadingSubcategories}
        />
        <MultipleSelect
          label={'Теги'}
          options={keywordList || []}
          setSelectedTags={setSelectedKeywords}
          selectedTags={selectedKeywords}
        />
      </Stack>
      <Button color={'primary'} variant={'contained'} onClick={onSetFilters}>
        Применить
      </Button>
    </Stack>
  )
}

export default MaterialFilters;
